const ShownOverWindowsEnum = {
  None: 'None',
  AddNewFee: 'AddNewFee',
  TipaltiEvaluatorData: 'TipaltiEvaluatorData',
  EditApolloIgnoredClientsWindow: 'EditApolloIgnoredClientsWindow',
  DetailedTaxWindow: 'DetailedTaxWindow',
  Apply: 'Apply',
  AddNewLineItem: 'AddNewLineItem',
  AddIgnoredSurvey: 'AddIgnoredSurvey',
  Upload: 'Upload',
  Approve: 'Approve',
  View: 'View',
  AssignmentsList: 'AssignmentsList',
  EvaluatorPayments: 'EvaluatorPayments',
  Edit: 'Edit',
  MatchList: 'MatchList',
  LinkList: 'LinkList',
  UploadXml: 'UploadXml',
  PaymentInformationValidation: 'PaymentInformationValidation',
  RequestPaymentDetailsReview: 'RequestPaymentDetailsReview',
};

export default ShownOverWindowsEnum;
